import { Row, Col } from "reactstrap";
import AutotaskTable from "./autotaskTable";

const QuoteOverviewSystem = ({quoteItems}) => {

    return (
        <>
        <Row className="mb-3">
            <Col xs="auto">
                <AutotaskTable quoteItems={quoteItems} />
            </Col>
        </Row>
        </>
    );
}

export default QuoteOverviewSystem;